// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-buttons-area .BaSe--button span {
  font-size: 13px;
  line-height: 1;
}

.modal-text-area .BaSe--paragraph {
  font-size: 13px;
}

.button-back .BaSe--button {
  background-color: var(--sebrae-white);
  border: 1px solid var(--sebrae-dark-gray3);
}
.button-back .BaSe--button:hover {
  background-color: var(--sebrae-light-gray4);
}
.button-back .BaSe--button span {
  color: var(--sebrae-dark-gray3);
}

.card-status {
  gap: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);
  min-height: 100px;
  padding: 10px 8px 10px 12px;
  position: relative;
  margin-bottom: 16px;
  background-color: var(--sebrae-white);
  display: flex;
}
.card-status-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 16px;
}
.card-status:before {
  content: "";
  width: 5px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: var(--card-gradient);
  border-radius: 8px 0 0 8px;
}
.card-status.disabled {
  opacity: 0.7;
  cursor: no-drop;
  pointer-events: none;
}
.card-status-wrapper {
  overflow: hidden;
  width: 100%;
  max-width: 420px;
}
.card-status-title {
  position: relative;
  color: var(--sebrae-gray);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 2px;
  line-height: 1.2;
  padding-right: 24px;
}
.card-status-title:first-letter {
  text-transform: uppercase;
}
.card-status-flag {
  display: inline-block;
  width: 106px;
  color: var(--sebrae-dark-gray2);
  background: #D4DADD;
  border-radius: 8px;
  padding: 2px 6px;
  margin: 0;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
}
.card-status-subtitle {
  color: var(--sebrae-dark-gray2);
  font-size: 10px;
  line-height: 1.2;
}
.card-status-subtitle .text-with-ellipsis {
  display: flex;
  gap: 4px;
  width: 100%;
  flex: auto;
}
.card-status-subtitle .text-with-ellipsis span {
  display: inline-block;
  min-width: fit-content;
}
.card-status-subtitle p {
  margin-bottom: 2px;
}
.card-status-subtitle span.dot {
  display: none;
}
.card-status-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
.card-status-progress .status {
  width: auto;
  text-align: center;
}
.card-status-progress .status p {
  display: block;
  font-size: 11px;
  color: var(--sebrae-dark-gray2);
}
.card-status-progress .status-label {
  width: 118px;
  height: 21px;
  margin: 8px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--sebrae-blue);
  border-radius: 8px;
  background: var(--sebrae-white-3);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.card-status-progress .status-label.status-progress {
  color: #AB6005;
  background: #FFEECC;
}
.card-status-progress .status-label.status-completed {
  color: var(--sebrae-green);
  background: var(--sebrae-light-green4);
}
.card-status-progress .status-label.status-late {
  color: var(--sebrae-red);
  background: #F3D8DA;
}
.card-status-progress .status-label.status-trash {
  color: var(--sebrae-dark-gray2);
  background: #D4DADD;
}
.card-status-progress .status-label.status-pending {
  color: var(--sebrae-blue);
  background: var(--sebrae-white-3);
}
.card-status-progress .status-label__monitoring {
  width: 188px;
}
.card-status-progress .status.status-monitoring .status-label {
  margin-top: 0;
  margin-bottom: 8px;
}
.card-status-progress .progress {
  width: 100%;
}
.card-status-progress .progress h4 {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: var(--sebrae-gray);
  margin-bottom: 6px;
}
.card-status-progress .progress .progress-bar-container {
  border: 2px solid var(--sebrae-light-gray4);
  height: 16px;
  max-width: 200px;
  filter: drop-shadow(0 2px 4px rgba(20, 46, 82, 0.2));
}
.card-status-actions .link {
  font-size: 13px;
  color: var(--sebrae-blue-7) !important;
}
.card-status .avatar-group {
  margin: 0 0 0 auto;
  justify-content: flex-end;
  width: 100%;
}
.card-status .open-options {
  border-radius: 100%;
  padding: 0;
  transition: 0.3s;
  min-width: 24px;
  height: 24px;
  position: absolute;
  right: 4px;
  top: 8px;
}
.card-status .options {
  position: absolute;
  right: 4px;
  top: 34px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray4);
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  z-index: 8;
  transition: 0.3s;
  display: none;
  align-items: center;
}
.card-status .options.open {
  display: flex;
}
.card-status .options ul {
  padding: 8px 0;
}
.card-status .options ul li button {
  padding: 0;
  width: 100%;
}
.card-status .options ul li .link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  padding: 8px 0;
  padding-left: 16px;
  padding-right: 42px;
}
.card-status .options ul li .link:hover {
  background-color: var(--sebrae-white-3);
}
.card-status .options ul li .link span {
  color: var(--sebrae-blue-6);
  font-size: 16px;
}
.card-status .options ul li a {
  text-decoration: none;
  color: inherit;
}
.card-status.removing {
  background-color: #eceeef;
  opacity: 0.8;
  pointer-events: none;
}
.card-status.in-trash .card-status-title {
  padding-right: 0;
}
@media screen and (min-width: 375px) {
  .card-status-subtitle {
    font-size: 13px;
  }
}
@media screen and (min-width: 768px) {
  .card-status {
    padding: 16px;
  }
  .card-status-title {
    padding-right: 0;
  }
  .card-status-flag {
    font-size: 10px;
    width: 98px;
    min-width: 98px;
  }
  .card-status-subtitle p {
    margin: 0;
  }
  .card-status-content {
    flex-direction: row;
  }
  .card-status-wrapper {
    width: 100%;
    max-width: 208px;
  }
  .card-status-wrapper__title {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .card-status-progress {
    width: 100%;
    max-width: 228px;
    padding: 6px 16px;
    border-left: 1px solid var(--sebrae-light-gray4);
    border-right: 1px solid var(--sebrae-light-gray4);
  }
  .card-status-actions {
    display: flex;
    flex: 1 1;
    justify-content: flex-end;
  }
  .card-status .avatar-group {
    max-width: 130px;
  }
  .card-status .open-options {
    position: relative;
    right: 0;
    top: 0;
  }
  .card-status .options {
    right: 20px;
    top: 70px;
  }
  .card-status.in-trash .card-status-wrapper {
    max-width: 100%;
  }
}
@media screen and (min-width: 1024px) {
  .card-status-flag {
    font-size: 11px;
    width: 106px;
    min-width: 106px;
  }
  .card-status-subtitle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 3px;
  }
  .card-status-subtitle p {
    width: auto;
    margin: 0;
  }
  .card-status-subtitle span.dot {
    display: inline-block;
  }
  .card-status-wrapper {
    max-width: 395px;
  }
  .card-status-progress {
    padding: 6px 24px;
    max-width: 270px;
    gap: 16px;
  }
  .card-status .avatar-group {
    max-width: 150px;
  }
}
@media screen and (min-width: 1280px) {
  .card-status-wrapper {
    max-width: 430px;
  }
  .card-status-content {
    gap: 24px;
  }
  .card-status-progress {
    max-width: 395px;
    gap: 24px;
  }
}

.share-details-popup {
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid var(--sebrae-light-gray4);
  box-shadow: 0px 4px 12px 0px rgba(20, 46, 82, 0.15);
  z-index: 10;
  min-width: 325px;
  padding-top: 16px;
  max-height: 230px;
  overflow: visible;
}
.share-details-popup .popup-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--sebrae-blue-6);
  display: block;
  margin: 0 0 16px 16px;
}
.share-details-popup .sorting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.share-details-popup .sorting-header .sorting-header-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
}
.share-details-popup .sorting-header button {
  border: 1px solid var(--sebrae-light-gray5);
}
.share-details-popup .share-details-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px;
  max-height: 175px;
  overflow-y: auto;
  overflow-x: visible;
}
.share-details-popup .share-details-content .share-detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}
.share-details-popup .share-details-content .share-detail-item .avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--sebrae-dark-gray2);
  flex-shrink: 0;
  margin-right: 0;
  border: none;
}
.share-details-popup .share-details-content .share-detail-item .avatar span {
  line-height: 1;
  font-weight: 600;
}
.share-details-popup .share-details-content .share-detail-item .user-info {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  min-width: 0;
  position: relative;
}
.share-details-popup .share-details-content .share-detail-item .user-info .user-name {
  font-size: 11px;
  line-height: 1.1;
  font-weight: 500;
  color: var(--sebrae-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
  max-width: none;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  border-radius: 4px;
  width: fit-content;
  transition: background-color 0.2s;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  width: 107px;
  margin-right: 8px;
  flex-shrink: 0;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge .role-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge.planner {
  cursor: default;
  justify-content: flex-start;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge.planner img {
  width: 16px;
  height: 16px;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge span {
  font-weight: 500;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge--static {
  cursor: default;
  pointer-events: none;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-badge--static .role-info {
  opacity: 0.8;
}
.share-details-popup .share-details-content .share-detail-item .user-info .role-selector {
  position: relative;
  display: flex;
}
.share-details-popup .order-popup {
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray4);
  box-shadow: 0px 2px 8px 0px rgba(20, 46, 82, 0.15);
  z-index: 1002;
  padding: 8px 0;
  min-width: 180px;
}
.share-details-popup .order-popup .order-option {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.share-details-popup .order-popup .order-option:hover {
  background-color: var(--sebrae-white-3);
}
.share-details-popup .order-popup .order-option.active {
  background-color: var(--sebrae-light-blue3);
}
.share-details-popup .order-popup .order-option.active span {
  color: var(--sebrae-blue-1);
  font-weight: 600;
}
.share-details-popup .order-popup .order-option span {
  font-size: 14px;
  color: var(--sebrae-blue-6);
  font-weight: 500;
}
.share-details-popup .change-role-popup {
  position: fixed;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray4);
  box-shadow: 0px 2px 8px 0px rgba(20, 46, 82, 0.15);
  z-index: 1001;
  padding: 8px 0;
  min-width: 160px;
  transform: none !important;
  margin: 0;
}
.share-details-popup .change-role-popup .role-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.share-details-popup .change-role-popup .role-option:hover {
  background-color: var(--sebrae-white-3);
}
.share-details-popup .change-role-popup .role-option span {
  font-size: 14px;
  color: var(--sebrae-blue-6);
  font-weight: 500;
}
.share-details-popup .change-role-popup .remove-option span {
  color: var(--sebrae-red-2);
}
.share-details-popup .change-role-popup .remove-option {
  border-top: 2px solid var(--sebrae-light-gray4);
}
@media (max-width: 512px) {
  .share-details-popup {
    right: -50%;
  }
}
@media (max-width: 400px) {
  .share-details-popup {
    right: -65%;
    min-width: 290px;
  }
}

.avatar-group {
  display: flex;
  align-items: center;
  cursor: default;
  position: relative;
  z-index: unset;
}
.avatar-group .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border: 1px solid white;
  margin-right: -6px;
  position: relative;
}
.avatar-group .avatar span {
  line-height: 0.5;
  font-weight: 400;
}
.avatar-group .avatar:first-child {
  background-color: var(--sebrae-purple-2);
  z-index: 3;
}
.avatar-group .avatar:nth-child(2) {
  background-color: var(--sebrae-dark-green2);
  z-index: 2;
}
.avatar-group .avatar.extra {
  background-color: var(--sebrae-light-gray3);
  color: var(--sebrae-blue-6);
  margin-right: -6px;
  font-size: 13px;
  z-index: 1;
}
.avatar-group .avatar.extra span {
  font-weight: 600;
}
.avatar-group .avatar .icon-role {
  background-color: var(--sebrae-white);
  padding: 1px;
  border-radius: 50%;
  position: absolute;
  bottom: -5px;
  right: -1px;
  z-index: 4;
}
.avatar-group .avatar .icon-role img {
  width: 11px;
  height: 11px;
}
.avatar-group .avatar-popup-container {
  margin-left: 8px;
  cursor: pointer;
}
.avatar-group .avatar-popup-container .BaSe--icon {
  cursor: pointer;
}
.avatar-group [data-tooltip] {
  position: relative;
}
.avatar-group [data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: #324d5b;
  color: white;
  font-weight: 400;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
  left: 50%;
  transform: translateX(-50%);
}
.avatar-group [data-tooltip]::after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
  left: 50%;
  transform: translateX(-50%);
}
.avatar-group [data-tooltip][data-tooltip-position=top]::before {
  bottom: calc(100% + 8px);
}
.avatar-group [data-tooltip][data-tooltip-position=top]::after {
  top: calc(100% - 39px);
  border-top-color: #324d5b;
}
.avatar-group [data-tooltip][data-tooltip-position=bottom]::before {
  top: calc(100% + 8px);
}
.avatar-group [data-tooltip][data-tooltip-position=bottom]::after {
  bottom: calc(100% - 22.5px);
  border-bottom-color: #324d5b;
}
.avatar-group [data-tooltip]:hover::before, .avatar-group [data-tooltip]:hover::after {
  opacity: 1;
}

.modal-style {
  position: relative;
  top: unset;
  right: unset;
  border: none;
  box-shadow: none;
  padding: 0;
}

.share-details-popup.modal-style {
  min-width: unset;
}

.share-details-content.modal-style {
  padding: 0 !important;
}

.avatar.modal-style {
  width: 32px !important;
  height: 32px !important;
  background-color: var(--sebrae-light-gray3) !important;
}

.user-info.modal-style .user-name {
  font-size: 13px !important;
  max-width: 230px !important;
}
.user-info.modal-style .role-badge {
  width: 132px !important;
  font-size: 13px !important;
}
.user-info.modal-style .role-badge img {
  width: 16px !important;
  height: 16px !important;
}

.share-planning {
  padding: 8px 16px 16px;
}
.share-planning-link {
  display: flex;
  flex-direction: row;
  gap: 24px;
  max-height: 40px;
  margin-bottom: 32px;
}
.share-planning-link input.BaSe--input-input {
  height: 40px !important;
  color: var(--sebrae-blue-7) !important;
}
.share-planning-link button {
  min-width: 132px;
}
@media (max-width: 768px) {
  .share-planning {
    padding-bottom: 130px;
  }
}

.confirmation-modal-body p {
  font-size: 16px;
  color: var(--sebrae-gray);
  margin-bottom: 32px;
}
.confirmation-modal-body .wrapper-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
}

.follow-up .side-modal__wrapper-modal {
  max-width: 720px !important;
}
.follow-up .side-modal__body {
  border-top: 1px solid var(--sebrae-light-gray4);
  padding: 16px 0;
}

.dialog-opinion__content.center {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.dialog-opinion__section {
  margin-bottom: 32px;
}
.dialog-opinion__title {
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-dark-gray2);
  margin-bottom: 16px;
}
.dialog-opinion__subtitle {
  font-size: 16px;
  font-weight: 400;
  color: var(--sebrae-gray);
  margin-bottom: 16px;
}
.dialog-opinion__button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.dialog-opinion__button .BaSe--button {
  width: 100%;
  font-size: 14px;
}
.dialog-opinion__button .BaSe--button span {
  font-size: inherit;
}
.dialog-opinion__cards {
  padding-right: 0;
}
.dialog-opinion__card {
  position: relative;
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  margin: 16px 0;
  border-radius: 4px;
  background-color: #F0F6FE;
  cursor: pointer;
}
.dialog-opinion__card__title {
  color: var(--sebrae-dark-gray3);
  font-size: 19px !important;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0;
}
.dialog-opinion__card__meta {
  gap: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.dialog-opinion__card__subtitle {
  color: var(--sebrae-dark-gray2);
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}
.dialog-opinion__card__subtitle strong {
  font-weight: 700;
  font-size: 16px !important;
}
.dialog-opinion__card__author {
  color: var(--sebrae-dark-gray2);
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}
.dialog-opinion__card__author strong {
  font-size: 16px !important;
}
.dialog-opinion__card.draft {
  background-color: #F0F6FE;
}
.dialog-opinion__card--comment {
  background-color: #F0F6FE;
}
.dialog-opinion__card--comment .dialog-opinion__card__title {
  color: var(--sebrae-dark-gray3);
}
.dialog-opinion__card--guidance {
  background-color: #F5F7FA;
}
.dialog-opinion__card--guidance .dialog-opinion__card__title {
  color: var(--sebrae-dark-gray2);
}
.dialog-opinion__card--guidance .dialog-opinion__card__text {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}
.dialog-opinion__card:first-of-type {
  margin-top: 0;
}
.dialog-opinion__card:last-of-type {
  margin-bottom: 0;
}
@media screen and (min-width: 768px) {
  .dialog-opinion__card {
    min-height: 79px;
  }
  .dialog-opinion__card__title {
    font-size: 19px !important;
  }
  .dialog-opinion__card__subtitle {
    font-size: 16px !important;
  }
  .dialog-opinion__card__author {
    font-size: 14px !important;
  }
}
@media screen and (max-width: 767px) {
  .dialog-opinion__card {
    height: auto;
  }
  .dialog-opinion__card__meta {
    gap: 0;
    flex-direction: column;
    align-items: flex-start;
  }
}
.dialog-opinion__card-guidance {
  background-color: #F5F7FA;
}
.dialog-opinion__form {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 0 16px 50px;
}
.dialog-opinion__form .BaSe--input {
  max-width: 100%;
}
.dialog-opinion__form .BaSe--input-wrapper-label {
  position: relative;
  margin: 0 0 2px;
}
.dialog-opinion__form .BaSe--input-label {
  line-height: 23px;
}
.dialog-opinion__form .wrapper-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 32px auto 0;
  width: calc(100% - 32px);
}
.dialog-opinion__form .wrapper-buttons .BaSe--button {
  width: 100%;
}
.dialog-opinion__form .ql-editor {
  height: 380px !important;
  max-height: 380px !important;
}
.dialog-opinion__form .only-view .BaSe--input-label {
  font-size: 13px !important;
  font-weight: 700 !important;
}
.dialog-opinion__form .only-view .BaSe--input-input {
  height: auto;
  opacity: 1;
  background: none;
  border: none !important;
  padding: 0;
  color: var(--sebrae-gray);
}
.dialog-opinion__form .only-view .ql-toolbar {
  display: none;
}
.dialog-opinion__form .only-view .ql-editor {
  padding: 0;
  height: auto !important;
  max-height: none !important;
}
.dialog-opinion .wrapper-modal {
  max-width: 100%;
  height: 100%;
  max-height: calc(100dvh - 56px);
}
@media screen and (min-width: 768px) {
  .dialog-opinion .wrapper-modal {
    max-width: 80vw;
    height: 90dvh;
  }
}
@media screen and (min-width: 1440px) {
  .dialog-opinion .wrapper-modal {
    max-width: 80vw;
    height: 85dvh;
  }
}
.dialog-opinion .modal-body {
  padding: 8px 0;
}
.dialog-opinion__empty {
  font-size: 16px;
}
@media screen and (min-width: 768px) {
  .dialog-opinion.form .wrapper-modal {
    overflow: inherit;
  }
}
.dialog-opinion__tabs {
  position: relative;
  width: 100%;
}
.dialog-opinion__tabs-head {
  display: flex;
  border-bottom: 1px solid var(--sebrae-light-gray4);
}
.dialog-opinion__tabs-head .tab {
  position: relative;
  flex: 1 1;
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 400;
  color: var(--sebrae-dark-gray3);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.dialog-opinion__tabs-head .tab.active {
  font-weight: 600;
  color: var(--sebrae-blue);
}
.dialog-opinion__tabs-head .tab.active:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 4px;
  bottom: 0;
  left: 0;
  background-color: var(--sebrae-blue);
}
.dialog-opinion__tabs-body {
  padding: 24px 32px;
}
.dialog-opinion__details {
  padding: 8px 32px 24px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.dialog-opinion__details .details-block {
  margin-bottom: 32px;
}
.dialog-opinion__details h4 {
  color: var(--sebrae-gray);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 8px;
}
.dialog-opinion__details p {
  color: var(--sebrae-gray);
  font-size: 19px !important;
  font-weight: 400;
  margin: 0;
}
.dialog-opinion__details .details-html {
  color: var(--sebrae-gray);
  font-size: 19px !important;
  line-height: 1.5;
}
.dialog-opinion__details .details-html strong {
  font-size: 19px !important;
}
.dialog-opinion__details .details-html p:last-child {
  margin-bottom: 0;
}
.dialog-opinion__details .details-download-card {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border: 1px solid #E0E5EB;
  border-radius: 4px;
  background-color: #F0F6FE;
  cursor: pointer;
}
.dialog-opinion__details .details-download-card__text {
  min-width: 0;
}
.dialog-opinion__details .details-download-card__title {
  color: #0F438A !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 1.4;
  margin-bottom: 4px;
}
.dialog-opinion__details .details-download-card__date {
  color: #394D60 !important;
  font-size: 11px !important;
  font-weight: 400 !important;
  line-height: 1.4;
}
.dialog-opinion__details .details-download-card__icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  display: block;
}
.dialog-opinion__details .details-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 32px;
}
.dialog-opinion__details .details-actions .BaSe--button {
  min-width: 208px;
}
.dialog-opinion .guidance-card-document-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: block;
  margin-top: 4px;
}
.dialog-opinion .guidance-card-content {
  flex: 1 1;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/card-status/index.scss"],"names":[],"mappings":"AAEI;EACE,eAAA;EACA,cAAA;AADN;;AAOE;EACE,eAAA;AAJJ;;AASE;EACE,qCAAA;EACA,0CAAA;AANJ;AAQI;EACE,2CAAA;AANN;AASI;EACE,+BAAA;AAPN;;AAYA;EACE,SAAA;EACA,kBAAA;EACA,6CAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;AATF;AAWE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AATJ;AAWE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;EACA,0BAAA;AATJ;AAWE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;AATJ;AAWE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AATJ;AAWE;EACE,kBAAA;EACA,yBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXJ;AAYI;EACE,yBAAA;AAVN;AAaE;EACE,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EAEE,eAAA;EACA,gBAAA;AAZN;AAeE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAbJ;AAeI;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AAbN;AAeM;EACE,qBAAA;EACA,sBAAA;AAbR;AAgBI;EACE,kBAAA;AAdN;AAgBI;EACE,aAAA;AAdN;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAfJ;AAiBI;EACE,WAAA;EACA,kBAAA;AAfN;AAiBM;EACE,cAAA;EACA,eAAA;EACA,+BAAA;AAfR;AAiBM;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kDAAA;AAjBR;AAmBQ;EACE,cAAA;EACA,mBAAA;AAjBV;AAmBQ;EACE,0BAAA;EACA,sCAAA;AAjBV;AAmBQ;EACE,wBAAA;EACA,mBAAA;AAjBV;AAmBQ;EACE,+BAAA;EACA,mBAAA;AAjBV;AAmBQ;EACE,yBAAA;EACA,iCAAA;AAjBV;AAmBQ;EACE,YAAA;AAjBV;AAsBQ;EACE,aAAA;EACA,kBAAA;AApBV;AAwBI;EACE,WAAA;AAtBN;AAwBM;EACE,cAAA;EAEE,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,kBAAA;AAxBR;AA0BM;EACE,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,oDAAA;AAxBR;AA6BI;EACE,eAAA;EACA,sCAAA;AA3BN;AA8BE;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;AA5BJ;AA8BE;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AA5BJ;AA8BE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,6CAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA5BJ;AA8BI;EACE,aAAA;AA5BN;AA+BI;EACE,cAAA;AA7BN;AA+BQ;EACE,UAAA;EACA,WAAA;AA7BV;AAgCQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA9BV;AAgCU;EACE,uCAAA;AA9BZ;AAiCU;EACE,2BAAA;EACA,eAAA;AA/BZ;AAmCQ;EACE,qBAAA;EACA,cAAA;AAjCV;AAuCE;EACE,yBAAA;EACA,YAAA;EACA,oBAAA;AArCJ;AAyCM;EACE,gBAAA;AAvCR;AA4CE;EACE;IACE,eAAA;EA1CJ;AACF;AA4CE;EAzQF;IA0QI,aAAA;EAzCF;EA2CE;IACE,gBAAA;EAzCJ;EA2CE;IACE,eAAA;IACA,WAAA;IACA,eAAA;EAzCJ;EA4CI;IACE,SAAA;EA1CN;EA6CE;IACE,mBAAA;EA3CJ;EA6CE;IACE,WAAA;IACA,gBAAA;EA3CJ;EA6CI;IACE,aAAA;IACA,mBAAA;IACA,QAAA;EA3CN;EA8CE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,gDAAA;IACA,iDAAA;EA5CJ;EA8CE;IACE,aAAA;IACA,SAAA;IACA,yBAAA;EA5CJ;EA8CE;IACE,gBAAA;EA5CJ;EA8CE;IACE,kBAAA;IACA,QAAA;IACA,MAAA;EA5CJ;EA8CE;IACE,WAAA;IACA,SAAA;EA5CJ;EAiDM;IACE,eAAA;EA/CR;AACF;AAmDE;EACE;IACE,eAAA;IACA,YAAA;IACA,gBAAA;EAjDJ;EAmDE;IACE,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,QAAA;EAjDJ;EAmDI;IACE,WAAA;IACA,SAAA;EAjDN;EAmDI;IACE,qBAAA;EAjDN;EAoDE;IACE,gBAAA;EAlDJ;EAoDE;IACE,iBAAA;IACA,gBAAA;IACA,SAAA;EAlDJ;EAoDE;IACE,gBAAA;EAlDJ;AACF;AAoDE;EACE;IACE,gBAAA;EAlDJ;EAoDE;IACE,SAAA;EAlDJ;EAoDE;IACE,gBAAA;IACA,SAAA;EAlDJ;AACF;;AAsDA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mDAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAnDF;AAqDE;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,qBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AApDJ;AAsDI;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AApDN;AAuDI;EACE,2CAAA;AArDN;AAyDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAvDJ;AAyDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAvDN;AAyDM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAvDR;AAyDQ;EACE,cAAA;EACA,gBAAA;AAvDV;AA2DM;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AAzDR;AA2DQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAzDV;AA4DQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA1DV;AA4DU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1DZ;AA6DU;EACE,eAAA;EACA,2BAAA;AA3DZ;AA6DY;EACE,WAAA;EACA,YAAA;AA3Dd;AA+DU;EACE,gBAAA;AA7DZ;AAiEQ;EACE,eAAA;EACA,oBAAA;AA/DV;AAiEU;EACE,YAAA;AA/DZ;AAmEQ;EACE,kBAAA;EACA,aAAA;AAjEV;AAuEE;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AArEJ;AAuEI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AArEN;AAuEM;EACE,uCAAA;AArER;AAwEM;EACE,2CAAA;AAtER;AAwEQ;EACE,2BAAA;EACA,gBAAA;AAtEV;AA0EM;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;AAxER;AA6EE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AA3EJ;AA6EI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AA3EN;AA6EM;EACE,uCAAA;AA3ER;AA8EM;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;AA5ER;AAiFM;EACE,0BAAA;AA/ER;AA6EI;EAIE,+CAAA;AA9EN;AAkFE;EAjOF;IAkOI,WAAA;EA/EF;AACF;AAiFE;EArOF;IAsOI,WAAA;IACA,gBAAA;EA9EF;AACF;;AAiFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AA9EF;AAgFE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA9EJ;AAgFI;EACE,gBAAA;EACA,gBAAA;AA9EN;AAiFI;EACE,wCAAA;EACA,UAAA;AA/EN;AAkFI;EACE,2CAAA;EACA,UAAA;AAhFN;AAmFI;EACE,2CAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAjFN;AAmFM;EACE,gBAAA;AAjFR;AAqFI;EACE,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAnFN;AAqFM;EACE,WAAA;EACA,YAAA;AAnFR;AAwFE;EACE,gBAAA;EACA,eAAA;AAtFJ;AAwFI;EACE,eAAA;AAtFN;AA0FE;EACE,kBAAA;AAxFJ;AA0FI;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AAxFN;AA2FI;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AAzFN;AA4FI;EACE,wBAAA;AA1FN;AA6FI;EACE,sBAAA;EACA,yBAAA;AA3FN;AA8FI;EACE,qBAAA;AA5FN;AA+FI;EACE,2BAAA;EACA,4BAAA;AA7FN;AAgGI;EAEE,UAAA;AA/FN;;AAoGA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAjGF;;AAoGA;EACE,gBAAA;AAjGF;;AAoGA;EACE,qBAAA;AAjGF;;AAoGA;EACE,sBAAA;EACA,uBAAA;EACA,sDAAA;AAjGF;;AAqGE;EACE,0BAAA;EACA,2BAAA;AAlGJ;AAoGE;EACE,uBAAA;EACA,0BAAA;AAlGJ;AAoGI;EACE,sBAAA;EACA,uBAAA;AAlGN;;AAuGA;EACE,sBAAA;AApGF;AAsGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AApGJ;AAsGI;EACE,uBAAA;EACA,sCAAA;AApGN;AAuGI;EACE,gBAAA;AArGN;AAyGE;EApBF;IAqBI,qBAAA;EAtGF;AACF;;AA0GE;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;AAvGJ;AA0GE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAxGJ;;AA6GE;EACE,2BAAA;AA1GJ;AA4GE;EACE,+CAAA;EACA,eAAA;AA1GJ;;AA+GE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AA5GJ;AA8GE;EACE,mBAAA;AA5GJ;AA8GE;EAEI,eAAA;EACA,gBAAA;EAEF,+BAAA;EACA,mBAAA;AA9GJ;AAgHE;EAEI,eAAA;EACA,gBAAA;EAEF,yBAAA;EACA,mBAAA;AAhHJ;AAkHE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAhHJ;AAkHI;EACE,WAAA;EACA,eAAA;AAhHN;AAkHM;EACE,kBAAA;AAhHR;AAwHE;EACE,gBAAA;AAtHJ;AAwHE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAtHJ;AAwHI;EACE,+BAAA;EAEE,0BAAA;EACA,gBAAA;EAEF,gBAAA;EACA,gBAAA;AAxHN;AA0HI;EACE,QAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAxHN;AA0HI;EACE,+BAAA;EAEE,0BAAA;EACA,gBAAA;EAEF,gBAAA;EACA,SAAA;AA1HN;AA4HM;EACE,gBAAA;EACA,0BAAA;AA1HR;AA6HI;EACE,+BAAA;EAEE,0BAAA;EACA,gBAAA;EAEF,gBAAA;EACA,SAAA;AA7HN;AA+HM;EACE,0BAAA;AA7HR;AAiII;EACE,yBAAA;AA/HN;AAkII;EACE,yBAAA;AAhIN;AAkIM;EACE,+BAAA;AAhIR;AAoII;EACE,yBAAA;AAlIN;AAoIM;EACE,+BAAA;AAlIR;AAqIM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AAnIR;AAuII;EACE,aAAA;AArIN;AAuII;EACE,gBAAA;AArIN;AAwII;EA3FF;IA4FI,gBAAA;EArIJ;EAuII;IACE,0BAAA;EArIN;EAuII;IACE,0BAAA;EArIN;EAuII;IACE,0BAAA;EArIN;AACF;AAwII;EAzGF;IA0GI,YAAA;EArIJ;EAuII;IACE,MAAA;IACA,sBAAA;IACA,uBAAA;EArIN;AACF;AAwIE;EACE,yBAAA;AAtIJ;AAwIE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAtIJ;AAwII;EACE,eAAA;AAtIN;AAwIM;EACE,kBAAA;EACA,eAAA;AAtIR;AAwIM;EACE,iBAAA;AAtIR;AAyII;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,wBAAA;AAvIN;AAyIM;EACE,WAAA;AAvIR;AA0II;EACE,wBAAA;EACA,4BAAA;AAxIN;AA4IQ;EAEI,0BAAA;EACA,2BAAA;AA3IZ;AA8IQ;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;AA5IV;AA+IM;EACE,aAAA;AA7IR;AA+IM;EACE,UAAA;EACA,uBAAA;EACA,2BAAA;AA7IR;AAiJE;EACE,eAAA;EACA,YAAA;EACA,+BAAA;AA/IJ;AAiJI;EALF;IAMI,eAAA;IACA,aAAA;EA9IJ;AACF;AA+II;EATF;IAUI,eAAA;IACA,aAAA;EA5IJ;AACF;AA8IE;EACE,cAAA;AA5IJ;AA8IE;EACE,eAAA;AA5IJ;AAgJM;EADF;IAEI,iBAAA;EA7IN;AACF;AAgJE;EACE,kBAAA;EACA,WAAA;AA9IJ;AAgJI;EACE,aAAA;EACA,kDAAA;AA9IN;AAgJM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEE,eAAA;EACA,gBAAA;EAEF,+BAAA;EACA,kDAAA;AAhJR;AAkJQ;EACE,gBAAA;EACA,yBAAA;AAhJV;AAkJU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;AAhJZ;AAqJI;EACE,kBAAA;AAnJN;AAsJE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AApJJ;AAsJI;EACE,mBAAA;AApJN;AAuJI;EACE,yBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,kBAAA;AAvJN;AA0JI;EACE,yBAAA;EAEE,0BAAA;EACA,gBAAA;EAEF,SAAA;AA1JN;AA6JI;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AA3JN;AA6JM;EACE,0BAAA;AA3JR;AA8JM;EACE,gBAAA;AA5JR;AAgKI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AA9JN;AAgKM;EACE,YAAA;AA9JR;AAiKM;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AA/JR;AAkKM;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;AAhKR;AAmKM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAjKR;AAqKI;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAnKN;AAqKM;EACE,gBAAA;AAnKR;AAwKE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAtKJ;AAyKE;EACE,SAAA;EACA,YAAA;AAvKJ","sourcesContent":[".modal-buttons-area {\n  .BaSe--button {\n    span {\n      font-size: 13px;\n      line-height: 1;\n    }\n  }\n}\n\n.modal-text-area {\n  .BaSe--paragraph {\n    font-size: 13px;\n  }\n}\n\n.button-back {\n  .BaSe--button {\n    background-color: var(--sebrae-white);\n    border: 1px solid var(--sebrae-dark-gray3);\n\n    &:hover {\n      background-color: var(--sebrae-light-gray4);\n    }\n\n    span {\n      color: var(--sebrae-dark-gray3);\n    }\n  }\n}\n\n.card-status {\n  gap: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);\n  min-height: 100px;\n  padding: 10px 8px 10px 12px;\n  position: relative;\n  margin-bottom: 16px;\n  background-color: var(--sebrae-white);\n  display: flex;\n\n  &-content {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    gap: 16px;\n  }\n  &:before {\n    content: \"\";\n    width: 5px;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    background: var(--card-gradient);\n    border-radius: 8px 0 0 8px;\n  }\n  &.disabled {\n    opacity: 0.7;\n    cursor: no-drop;\n    pointer-events: none;\n  }\n  &-wrapper {\n    overflow: hidden;\n    width: 100%;\n    max-width: 420px;\n  }\n  &-title {\n    position: relative;\n    color: var(--sebrae-gray);\n    font: {\n      size: 16px;\n      weight: 700;\n    }\n    margin-bottom: 2px;\n    line-height: 1.2;\n    padding-right: 24px;\n    &:first-letter {\n      text-transform: uppercase;\n    }\n  }\n  &-flag {\n    display: inline-block;\n    width: 106px;\n    color: var(--sebrae-dark-gray2);\n    background: #D4DADD;\n    border-radius: 8px;\n    padding: 2px 6px;\n    margin: 0;\n    text-align: center;\n    font: {\n      size: 11px;\n      weight: 500;\n    }\n  }\n  &-subtitle {\n    color: var(--sebrae-dark-gray2);\n    font-size: 10px;\n    line-height: 1.2;\n\n    .text-with-ellipsis {\n      display: flex;\n      gap: 4px;\n      width: 100%;\n      flex: auto;\n\n      span {\n        display: inline-block;\n        min-width: fit-content;\n      }\n    }\n    p {\n      margin-bottom: 2px;\n    }\n    span.dot {\n      display: none;\n    }\n  }\n  &-progress {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n\n    .status {\n      width: auto;\n      text-align: center;\n\n      p {\n        display: block;\n        font-size: 11px;\n        color: var(--sebrae-dark-gray2);\n      }\n      &-label {\n        width: 118px;\n        height: 21px;\n        margin: 8px auto 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font: {\n          size: 11px;\n          weight: 700;\n        }\n        color: var(--sebrae-blue);\n        border-radius: 8px;\n        background: var(--sebrae-white-3);\n        transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n        &.status-progress {\n          color: #AB6005;\n          background: #FFEECC;\n        }\n        &.status-completed {\n          color: var(--sebrae-green);\n          background: var(--sebrae-light-green4);\n        }\n        &.status-late {\n          color: var(--sebrae-red);\n          background: #F3D8DA;\n        }\n        &.status-trash {\n          color: var(--sebrae-dark-gray2);\n          background: #D4DADD;\n        }\n        &.status-pending {\n          color: var(--sebrae-blue);\n          background: var(--sebrae-white-3);\n        }\n        &__monitoring {\n          width: 188px;\n        }\n      }\n\n      &.status-monitoring {\n        .status-label {\n          margin-top: 0;\n          margin-bottom: 8px;\n        }\n      }\n    }\n    .progress {\n      width: 100%;\n\n      h4 {\n        display: block;\n        font: {\n          size: 13px;\n          weight: 700;\n        }\n        color: var(--sebrae-gray);\n        margin-bottom: 6px;\n      }\n      .progress-bar-container {\n        border: 2px solid var(--sebrae-light-gray4);\n        height: 16px;\n        max-width: 200px;\n        filter: drop-shadow(0 2px 4px rgba(20, 46, 82, 0.20));\n      }\n    }\n  }\n  &-actions {\n    .link {\n      font-size: 13px;\n      color: var(--sebrae-blue-7)!important;\n    }\n  }\n  .avatar-group {\n    margin: 0 0 0 auto;\n    justify-content: flex-end;\n    width: 100%;\n  }\n  .open-options {\n    border-radius: 100%;\n    padding: 0;\n    transition: 0.3s;\n    min-width: 24px;\n    height: 24px;\n    position: absolute;\n    right: 4px;\n    top: 8px;\n  }\n  .options {\n    position: absolute;\n    right: 4px;\n    top: 34px;\n    background: #ffffff;\n    border-radius: 4px;\n    border: 1px solid var(--sebrae-light-gray4);\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n    z-index: 8;\n    transition: 0.3s;\n    display: none;\n    align-items: center;\n\n    &.open {\n      display: flex;\n    }\n\n    ul {\n      padding: 8px 0;\n      li {\n        button {\n          padding: 0;\n          width: 100%;\n        }\n\n        .link {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          text-decoration: none;\n          padding: 8px 0;\n          padding-left: 16px;\n          padding-right: 42px;\n\n          &:hover {\n            background-color: var(--sebrae-white-3);\n          }\n\n          span {\n            color: var(--sebrae-blue-6);\n            font-size: 16px;\n          }\n        }\n\n        a {\n          text-decoration: none;\n          color: inherit;\n        }\n      }\n    }\n  }\n\n  &.removing {\n    background-color: #eceeef;\n    opacity: 0.8;\n    pointer-events: none;\n  }\n  &.in-trash {\n    .card-status {\n      &-title {\n        padding-right: 0;\n      }\n    }\n  }\n\n  @media screen and (min-width: 375px) {\n    &-subtitle {\n      font-size: 13px;\n    }\n  }\n  @media screen and (min-width: 768px) {\n    padding: 16px;\n\n    &-title {\n      padding-right: 0;\n    }\n    &-flag {\n      font-size: 10px;\n      width: 98px;\n      min-width: 98px;\n    }\n    &-subtitle {\n      p {\n        margin: 0;\n      }\n    }\n    &-content {\n      flex-direction: row;\n    }\n    &-wrapper {\n      width: 100%;\n      max-width: 208px;\n\n      &__title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n    &-progress {\n      width: 100%;\n      max-width: 228px;\n      padding: 6px 16px;\n      border-left: 1px solid var(--sebrae-light-gray4);\n      border-right: 1px solid var(--sebrae-light-gray4);\n    }\n    &-actions {\n      display: flex;\n      flex: 1;\n      justify-content: flex-end;\n    }\n    .avatar-group {\n      max-width: 130px;\n    }\n    .open-options {\n      position: relative;\n      right: 0;\n      top: 0;\n    }\n    .options {\n      right: 20px;\n      top: 70px;\n    }\n\n    &.in-trash {\n      .card-status {\n        &-wrapper {\n          max-width: 100%;\n        }\n      }\n    }\n  }\n  @media screen and (min-width: 1024px) {\n    &-flag {\n      font-size: 11px;\n      width: 106px;\n      min-width: 106px;\n    }\n    &-subtitle {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      gap: 3px;\n\n      p {\n        width: auto;\n        margin: 0;\n      }\n      span.dot {\n        display: inline-block;\n      }\n    }\n    &-wrapper {\n      max-width: 395px;\n    }\n    &-progress {\n      padding: 6px 24px;\n      max-width: 270px;\n      gap: 16px;\n    }\n    .avatar-group {\n      max-width: 150px;\n    }\n  }\n  @media screen and (min-width: 1280px) {\n    &-wrapper {\n      max-width: 430px;\n    }\n    &-content {\n      gap: 24px;\n    }\n    &-progress {\n      max-width: 395px;\n      gap: 24px;\n    }\n  }\n}\n\n.share-details-popup {\n  position: absolute;\n  right: 0;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid var(--sebrae-light-gray4);\n  box-shadow: 0px 4px 12px 0px rgba(20, 46, 82, 0.15);\n  z-index: 10;\n  min-width: 325px;\n  padding-top: 16px;\n  max-height: 230px;\n  overflow: visible;\n\n  .popup-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--sebrae-blue-6);\n    display: block;\n    margin: 0 0 16px 16px;\n  }\n\n  .sorting-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n\n    .sorting-header-title {\n      font-size: 16px;\n      font-weight: 700;\n      color: var(--sebrae-blue-6);\n    }\n\n    button {\n      border: 1px solid var(--sebrae-light-gray5);\n    }\n  }\n\n  .share-details-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 0 16px 16px;\n    max-height: 175px;\n    overflow-y: auto;\n    overflow-x: visible;\n\n    .share-detail-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      position: relative;\n\n      .avatar {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--sebrae-dark-gray2);\n        flex-shrink: 0;\n        margin-right: 0;\n        border: none;\n\n        span {\n          line-height: 1;\n          font-weight: 600;\n        }\n      }\n\n      .user-info {\n        flex: 1;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        gap: 4px;\n        min-width: 0;\n        position: relative;\n\n        .user-name {\n          font-size: 11px;\n          line-height: 1.1;\n          font-weight: 500;\n          color: var(--sebrae-gray);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          flex: 1;\n          min-width: 0;\n          max-width: none;\n        }\n\n        .role-badge {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          gap: 8px;\n          font-size: 11px;\n          border-radius: 4px;\n          width: fit-content;\n          transition: background-color 0.2s;\n          cursor: pointer;\n          user-select: none;\n          width: 107px;\n          margin-right: 8px;\n          flex-shrink: 0;\n\n          .role-info {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n          }\n\n          &.planner {\n            cursor: default;\n            justify-content: flex-start;\n\n            img {\n              width: 16px;\n              height: 16px;\n            }\n          }\n\n          span {\n            font-weight: 500;\n          }\n        }\n\n        .role-badge--static {\n          cursor: default;\n          pointer-events: none;\n\n          .role-info {\n            opacity: 0.8;\n          }\n        }\n\n        .role-selector {\n          position: relative;\n          display: flex;\n        }\n      }\n    }\n  }\n\n  .order-popup {\n    position: absolute;\n    right: 0;\n    background: #ffffff;\n    border-radius: 4px;\n    border: 1px solid var(--sebrae-light-gray4);\n    box-shadow: 0px 2px 8px 0px rgba(20, 46, 82, 0.15);\n    z-index: 1002;\n    padding: 8px 0;\n    min-width: 180px;\n\n    .order-option {\n      display: flex;\n      align-items: center;\n      padding: 10px 16px;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: var(--sebrae-white-3);\n      }\n\n      &.active {\n        background-color: var(--sebrae-light-blue3);\n\n        span {\n          color: var(--sebrae-blue-1);\n          font-weight: 600;\n        }\n      }\n\n      span {\n        font-size: 14px;\n        color: var(--sebrae-blue-6);\n        font-weight: 500;\n      }\n    }\n  }\n\n  .change-role-popup {\n    position: fixed;\n    background: #ffffff;\n    border-radius: 4px;\n    border: 1px solid var(--sebrae-light-gray4);\n    box-shadow: 0px 2px 8px 0px rgba(20, 46, 82, 0.15);\n    z-index: 1001;\n    padding: 8px 0;\n    min-width: 160px;\n    transform: none !important;\n    margin: 0;\n\n    .role-option {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 10px 16px;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: var(--sebrae-white-3);\n      }\n\n      span {\n        font-size: 14px;\n        color: var(--sebrae-blue-6);\n        font-weight: 500;\n      }\n    }\n\n    .remove-option {\n      span {\n        color: var(--sebrae-red-2);\n      }\n      border-top: 2px solid var(--sebrae-light-gray4);\n    }\n  }\n\n  @media (max-width: 512px) {\n    right: -50%;\n  }\n\n  @media (max-width: 400px) {\n    right: -65%;\n    min-width: 290px;\n  }\n}\n\n.avatar-group {\n  display: flex;\n  align-items: center;\n  cursor: default;\n  position: relative;\n  z-index: unset;\n\n  .avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 14px;\n    color: white;\n    border: 1px solid white;\n    margin-right: -6px;\n    position: relative;\n\n    span {\n      line-height: 0.5;\n      font-weight: 400;\n    }\n\n    &:first-child {\n      background-color: var(--sebrae-purple-2);\n      z-index: 3;\n    }\n\n    &:nth-child(2) {\n      background-color: var(--sebrae-dark-green2);\n      z-index: 2;\n    }\n\n    &.extra {\n      background-color: var(--sebrae-light-gray3);\n      color: var(--sebrae-blue-6);\n      margin-right: -6px;\n      font-size: 13px;\n      z-index: 1;\n\n      span {\n        font-weight: 600;\n      }\n    }\n\n    .icon-role {\n      background-color: var(--sebrae-white);\n      padding: 1px;\n      border-radius: 50%;\n      position: absolute;\n      bottom: -5px;\n      right: -1px;\n      z-index: 4;\n\n      img {\n        width: 11px;\n        height: 11px;\n      }\n    }\n  }\n\n  .avatar-popup-container {\n    margin-left: 8px;\n    cursor: pointer;\n\n    .BaSe--icon {\n      cursor: pointer;\n    }\n  }\n\n  [data-tooltip] {\n    position: relative;\n\n    &::before {\n      content: attr(data-tooltip);\n      position: absolute;\n      background-color: #324d5b;\n      color: white;\n      font-weight: 400;\n      padding: 4px 6px;\n      border-radius: 4px;\n      font-size: 11px;\n      white-space: nowrap;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.2s ease;\n      z-index: 1000;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      border: 6px solid transparent;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.2s ease;\n      z-index: 1000;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n    &[data-tooltip-position=\"top\"]::before {\n      bottom: calc(100% + 8px);\n    }\n\n    &[data-tooltip-position=\"top\"]::after {\n      top: calc(100% - 39px);\n      border-top-color: #324d5b;\n    }\n\n    &[data-tooltip-position=\"bottom\"]::before {\n      top: calc(100% + 8px);\n    }\n\n    &[data-tooltip-position=\"bottom\"]::after {\n      bottom: calc(100% - 22.5px);\n      border-bottom-color: #324d5b;\n    }\n\n    &:hover::before,\n    &:hover::after {\n      opacity: 1;\n    }\n  }\n}\n\n.modal-style {\n  position: relative;\n  top: unset;\n  right: unset;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n.share-details-popup.modal-style {\n  min-width: unset;\n}\n\n.share-details-content.modal-style {\n  padding: 0 !important;\n}\n\n.avatar.modal-style {\n  width: 32px !important;\n  height: 32px !important;\n  background-color: var(--sebrae-light-gray3) !important;\n}\n\n.user-info.modal-style {\n  .user-name {\n    font-size: 13px !important;\n    max-width: 230px !important;\n  }\n  .role-badge {\n    width: 132px !important;\n    font-size: 13px !important;\n\n    img {\n      width: 16px !important;\n      height: 16px !important;\n    }\n  }\n}\n\n.share-planning {\n  padding: 8px 16px 16px;\n\n  &-link {\n    display: flex;\n    flex-direction: row;\n    gap: 24px;\n    max-height: 40px;\n    margin-bottom: 32px;\n\n    input.BaSe--input-input {\n      height: 40px !important;\n      color: var(--sebrae-blue-7) !important;\n    }\n\n    button {\n      min-width: 132px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding-bottom: 130px;\n  }\n}\n\n.confirmation-modal-body {\n  p {\n    font-size: 16px;\n    color: var(--sebrae-gray);\n    margin-bottom: 32px;\n  }\n\n  .wrapper-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 24px;\n  }\n}\n\n.follow-up {\n  .side-modal__wrapper-modal {\n    max-width: 720px!important;\n  }\n  .side-modal__body {\n    border-top: 1px solid var(--sebrae-light-gray4);\n    padding: 16px 0;\n  }\n}\n\n.dialog-opinion {\n  &__content.center {\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n  }\n  &__section {\n    margin-bottom: 32px;\n  }\n  &__title {\n    font: {\n      size: 16px;\n      weight: 700;\n    }\n    color: var(--sebrae-dark-gray2);\n    margin-bottom: 16px;\n  }\n  &__subtitle {\n    font: {\n      size: 16px;\n      weight: 400;\n    }\n    color: var(--sebrae-gray);\n    margin-bottom: 16px;\n  }\n  &__button {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    .BaSe--button {\n      width: 100%;\n      font-size: 14px;\n\n      span {\n        font-size: inherit;\n      }\n    }\n\n    //&.center {\n    //  justify-content: center;\n    //}\n  }\n  &__cards {\n    padding-right: 0;\n  }\n  &__card {\n    position: relative;\n    width: 100%;\n    height: 83px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 16px;\n    margin: 16px 0;\n    border-radius: 4px;\n    background-color: #F0F6FE;\n    cursor: pointer;\n\n    &__title {\n      color: var(--sebrae-dark-gray3);\n      font: {\n        size: 19px!important;\n        weight: 700;\n      }\n      line-height: 1.2;\n      margin-bottom: 0;\n    }\n    &__meta {\n      gap: 8px;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n    }\n    &__subtitle {\n      color: var(--sebrae-dark-gray2);\n      font: {\n        size: 11px!important;\n        weight: 400;\n      }\n      line-height: 1.2;\n      margin: 0;\n\n      strong {\n        font-weight: 700;\n        font-size: 16px !important;\n      }\n    }\n    &__author {\n      color: var(--sebrae-dark-gray2);\n      font: {\n        size: 11px!important;\n        weight: 400;\n      }\n      line-height: 1.2;\n      margin: 0;\n\n      strong {\n        font-size: 16px !important;\n      }\n    }\n\n    &.draft {\n      background-color: #F0F6FE;\n    }\n\n    &--comment {\n      background-color: #F0F6FE;\n\n      .dialog-opinion__card__title {\n        color: var(--sebrae-dark-gray3);\n      }\n    }\n\n    &--guidance {\n      background-color: #F5F7FA;\n\n      .dialog-opinion__card__title {\n        color: var(--sebrae-dark-gray2);\n      }\n\n      .dialog-opinion__card__text {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        flex: 1;\n      }\n    }\n\n    &:first-of-type {\n      margin-top: 0;\n    }\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    @media screen and (min-width: 768px) {\n      min-height: 79px;\n\n      &__title {\n        font-size: 19px!important;\n      }\n      &__subtitle {\n        font-size: 16px!important;\n      }\n      &__author {\n        font-size: 14px!important;\n      }\n    }\n\n    @media screen and (max-width: 767px) {\n      height: auto;\n\n      &__meta {\n        gap: 0;\n        flex-direction: column;\n        align-items: flex-start;\n      }\n    }\n  }\n  &__card-guidance {\n    background-color: #F5F7FA;\n  }\n  &__form {\n    position: relative;\n    width: 100%;\n    min-height: 100%;\n    padding: 0 16px 50px;\n\n    .BaSe--input {\n      max-width: 100%;\n\n      &-wrapper-label {\n        position: relative;\n        margin: 0 0 2px;\n      }\n      &-label {\n        line-height: 23px;\n      }\n    }\n    .wrapper-buttons {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 10px;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: 32px auto 0;\n      width: calc(100% - 32px);\n\n      .BaSe--button {\n        width: 100%;\n      }\n    }\n    .ql-editor {\n      height: 380px!important;\n      max-height: 380px!important;\n    }\n    .only-view {\n      .BaSe--input {\n        &-label {\n          font: {\n            size: 13px!important;\n            weight: 700!important;\n          }\n        }\n        &-input {\n          height: auto;\n          opacity: 1;\n          background: none;\n          border: none!important;\n          padding: 0;\n          color: var(--sebrae-gray);\n        }\n      }\n      .ql-toolbar {\n        display: none;\n      }\n      .ql-editor {\n        padding: 0;\n        height: auto!important;\n        max-height: none!important;\n      }\n    }\n  }\n  .wrapper-modal {\n    max-width: 100%;\n    height: 100%;\n    max-height: calc(100dvh - 56px);\n\n    @media screen and (min-width: 768px) {\n      max-width: 80vw;\n      height: 90dvh;\n    }\n    @media screen and (min-width: 1440px) {\n      max-width: 80vw;\n      height: 85dvh;\n    }\n  }\n  .modal-body {\n    padding: 8px 0;\n  }\n  &__empty {\n    font-size: 16px;\n  }\n  &.form {\n    .wrapper-modal {\n      @media screen and (min-width: 768px) {\n        overflow: inherit;\n      }\n    }\n  }\n  &__tabs {\n    position: relative;\n    width: 100%;\n\n    &-head {\n      display: flex;\n      border-bottom: 1px solid var(--sebrae-light-gray4);\n\n      .tab {\n        position: relative;\n        flex: 1;\n        width: 100%;\n        height: 44px;\n        font: {\n          size: 16px;\n          weight: 400;\n        }\n        color: var(--sebrae-dark-gray3);\n        transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n        &.active {\n          font-weight: 600;\n          color: var(--sebrae-blue);\n\n          &:after {\n            content: '';\n            position: absolute;\n            width: 100%;\n            height: 4px;\n            bottom: 0;\n            left: 0;\n            background-color: var(--sebrae-blue);\n          }\n        }\n      }\n    }\n    &-body {\n      padding: 24px 32px;\n    }\n  }\n  &__details {\n    padding: 8px 32px 24px;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .details-block {\n      margin-bottom: 32px;\n    }\n\n    h4 {\n      color: var(--sebrae-gray);\n      font: {\n        size: 16px;\n        weight: 700;\n      }\n      line-height: 1.4;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: var(--sebrae-gray);\n      font: {\n        size: 19px !important;\n        weight: 400;\n      }\n      margin: 0;\n    }\n\n    .details-html {\n      color: var(--sebrae-gray);\n      font-size: 19px !important;\n      line-height: 1.5;\n\n      strong {\n        font-size: 19px !important;\n      }\n\n      p:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    .details-download-card {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n      padding: 12px 16px;\n      border: 1px solid #E0E5EB;\n      border-radius: 4px;\n      background-color: #F0F6FE;\n      cursor: pointer;\n\n      &__text {\n        min-width: 0;\n      }\n\n      &__title {\n        color: #0F438A !important;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        line-height: 1.4;\n        margin-bottom: 4px;\n      }\n\n      &__date {\n        color: #394D60 !important;\n        font-size: 11px !important;\n        font-weight: 400 !important;\n        line-height: 1.4;\n      }\n\n      &__icon {\n        width: 13px;\n        height: 13px;\n        flex-shrink: 0;\n        display: block;\n      }\n    }\n\n    .details-actions {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: auto;\n      padding-top: 32px;\n\n      .BaSe--button {\n        min-width: 208px;\n      }\n    }\n  }\n\n  .guidance-card-document-icon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    display: block;\n    margin-top: 4px;\n  }\n\n  .guidance-card-content {\n    flex: 1;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
